<template>
  <div class="home-news">
    <div class="content">
      <h1>
        通知公告
        <router-link to="./notice" class="more pull-right" replace>
          查看更多<i class="iconfont icon-tuxing margin-left-10"></i>
        </router-link>
      </h1>
      <div class="clearfix"></div>
      <a-spin :spinning="noticeSpinning">
        <ul class="home-news-ul" v-if="list.length">
          <li v-for="item of list" :key="item.id" :to="'/detail/' + item.id">
            <router-link :to="`/detail/${item.id}?type=notify`">
              <div class="row newul" @mouseover="changeActive($event)" @mouseleave="removeActive($event)">
                <div class="col-md-12">
                  <div class="news-detail">
                    <div class="title">
                      <span class="slot ellipsis" style="flex: 1; padding-right: 20px; font-size: 15px;">{{ item.title }}</span>
                      <span class="pull-right">{{ item.publishTime }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
        <ul v-else class="home-news-ul">
          <ul>无通知公告</ul>
        </ul>
      </a-spin>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeNews',
  data: function () {
    return {
      list: [],
      noticeSpinning: true
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      this.axios
        .get(`/biz/home/notify/list`, { params: { pageNo: 1, pageSize: 4 } })
        .then((res) => {
          this.noticeSpinning = false
          if (res.result.records) {
            this.list = res.result.records.slice(0, 4)
          }
        })
    }else{
      this.common.toURL('/login')
    }

  },
  methods: {
    changeActive: function ($event) {
    },
    removeActive: function ($event) {
    },
    gotoDetail(id) {
      this.$router.push({ name: '/detail/', params: { id, type: 'notify' } })
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.home-news {
  padding: 16px 0;
  .content {
    margin: 0 auto;
    h1 {
      font-size: 18px;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 16px;

      .english {
        color: #999;
        font-size: 14px;
        font-weight: normal;
        text-transform: Uppercase;
      }
    }
  }

  .home-news-ul {
    background: #fff;
    padding: 16px;
    height: 150px;

    li {
      a {
        color: #333;

        &:hover {
          text-decoration: none;
          color: $bgColor;
        }

        & .title {
          ellipsis();
          display: flex;
        }

        & .date {
          color: #999;
        }

        & .detail {
          color: #999;
          margin-top: 10px;
          line-height: 24px;
          ellipsis3();
        }
      }

      .news-detail {
        /* &:hover{
          color:$bgColor;
          & .year{
            color:$bgColor;
          }
          & .detail{
            color:$bgColor;
          }
        } */
        margin-bottom: 20px;

        .time {
          width: 100px;
          position: absolute;
          text-align: center;

          .time {
            color: #999;
          }
        }

        .news-content {
          margin-left: 120px;
        }
      }
    }
  }
}

.newsul {
  position: relative;
}

.active {
  transform: scale(1.4);
}

.more {
  color: #999;
  font-size: 14px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/News.vue